// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wxproduct .van-tab {\n  font-size: 45px;\n  color: #333;\n  line-height: 88px;\n}\n.wxproduct .van-tabs--line .van-tabs__wrap {\n  height: 88px;\n}\n.wxproduct .van-tab__text--ellipsis {\n  flex: none !important;\n}\n.wxproduct .van-tabs__line {\n  width: 120px;\n}\n.wxproduct .van-tabs__content {\n  margin-top: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
